import { fixUrl } from '@/utils/format'

export function formatCountryInfo(data) {
    const entries = []
    const generalData = data.general && data.general.length ? data.general[0] : false
    const trafficData = data.traffic && data.traffic.length ? data.traffic[0] : false
    const chargesData = data.charges && data.charges.length ? data.charges : false
    const fuelData = data.fuel && data.fuel.length ? data.fuel[0] : false
    const additionalInformationData = data.additionalInformation && data.additionalInformation.length ? data.additionalInformation[0] : false
    if(generalData) {
        const entry = {
            title: 'Allgemeine Informationen',
            content: formatGeneralInfo(generalData)
        }

        entries.push(entry)
    }
    if(trafficData) {
        const entry = {
            title: 'Verkehrsbestimmungen',
            content: formatTrafficInfo(trafficData)
        }
        entries.push(entry)
    }
    if(chargesData) {
        const entry = {
            title: 'Maut & Vignette',
            type: 'tolls-vignette',
            content: formatChargesInfo(chargesData)
        }
        entries.push(entry)
    }
    if(fuelData) {
        const entry = {
            title: 'Kraftstoff',
            content: formatFuelInfo(fuelData)
        }
        entries.push(entry)
    }
    if(additionalInformationData) {
        const entry = {
            title: 'Weitere wichtige Informationen',
            content: formatAdditionalInfo(additionalInformationData)
        }
        entries.push(entry)
    }

    return entries
}

function formatGeneralInfo(data) {
    const content = []
    if(data.money && data.money.currency && data.money.currency.value) {
        const moneyContent = {
            label: 'Währung',
            text: data.money.currency.value
        }
        if(data.money.comment?.value?.text) {
            moneyContent.text += `<br>${data.money.comment.value.text}`
        }
        content.push(moneyContent)
    }
    if(data.time && data.time.timezone && data.time.timezone.value) {
        const timeContent = {
            label: 'Zeitverschiebung',
            text: data.time.timezone.value
        }
        if(data.time.hasSummertime?.value !== undefined && data.time.hasSummertime?.value === false) timeContent.text += `<br>Keine Sommerzeit`
        content.push(timeContent)
    }
    if(data.documents) {
        let text = ''
        if(data.documents.identityCard && data.documents.identityCard.value) text += 'Personalausweis'
        if(data.documents.passport && data.documents.passport.value) text += `${text !== '' ? ', ' : ''}Reisepass`
        if(data.documents.visa && data.documents.visa.value) text += `${text !== '' ? ', ' : ''}Visum`
        if(data.documents.comment?.value) {
            text += `<br>${data.documents.comment.value.title ? `<br>${data.documents.comment.value.title}<br>` : ''}${data.documents.comment.value.text || ''}${data.documents.comment.value.link ? `<br><a href="${data.documents.comment.value.link}" target="_blank">${data.documents.comment.value.link}</a>` : ''}`
        }
        if(text !== '') {
            content.push({
                label: 'Personaldokumente',
                text: text
            })
        }
    }

    if(data.electricity && data.electricity.plugType && data.electricity.plugType.value) {
        let text = data.electricity.plugType.value
        if(data.electricity.availableAtOeamtc && data.electricity.availableAtOeamtc.value && data.electricity.availableAtOeamtc.value === 'true') text += `<br>Am Stützpunkt erhältlich: <a href="https://www.oeamtc.at/standorte" target="_blank">www.oeamtc.at/standorte</a>`
        content.push({
            label: 'Reisestecker',
            text: text
        })
    }

    if(data.insurance && data.insurance.comment) {
        let text = data.insurance.comment.value.text
        if(data.insurance.comment.value.link) text += `<a href="${fixUrl(data.insurance.comment.value.link)}" target="_blank">${data.insurance.comment.value.link}</a>`
        content.push({
            label: 'Versicherung',
            text: text
        })
    }

    if(data.additionalInformation && data.additionalInformation.length > 0) {
        data.additionalInformation.forEach(info => {
            content.push({
                label: info.value.title,
                text: info.value.text + `${info.value.link ? ` <a href="${fixUrl(info.value.link)}" target="_blank">${info.value.link}</a>` : ''}`
            })
        })
    }

    return content
}

function formatTrafficInfo(data) {
    const content = []
    if(data.documents) {
        let text = ''
        if(data.documents.driversLicence && data.documents.driversLicence.value) text += `Führerschein`
        if(data.documents.certificate && data.documents.certificate.value) text += `${text !== '' ? ', ' : ''}Zulassungsschein`
        if(data.documents.insuranceCard && data.documents.insuranceCard.value) text += `${text !== '' ? ', ' : ''}Versicherungskarte`
        if(data.documents.insuranceCardLarge && data.documents.insuranceCardLarge.value) text += `${text !== '' ? ', ' : ''}Versicherungskarte Groß`
        if(data.documents.comment && data.documents.comment.value) {
            text += `${text !== '' ? '. ' : ''}${data.documents.comment.value.text}`
            if(data.documents.comment.value.link) text += ` <a href="${fixUrl(data.documents.comment.value.link)}" target="_blank">${data.documents.comment.value.link}</a>`
        }
        if(text !== '') {
            content.push({
                label: 'Kfz-Dokumente',
                text: text
            })
        }
    }

    if(data.speedLimits) {
        let text = ''
        if(data.speedLimits.city) text += `Innerorts: ${data.speedLimits.city.value}km/h<br>`
        if(data.speedLimits.federal) text += `Außerorts: ${data.speedLimits.federal.value}km/h<br>`
        if(data.speedLimits.expressway) text += `Schnellstraße: ${data.speedLimits.expressway.value}km/h<br>`
        if(data.speedLimits.highway) text += `Autobahn: ${data.speedLimits.highway.value}km/h<br>`

        if(text !== '') {
            content.push({
                label: 'Höchstgeschwindigkeiten',
                text: text
            })
        }
    }

    if(data.alcoholLimits && data.alcoholLimits.limit) {
        let text = `${data.alcoholLimits.limit.value} Promille`
        if(data.alcoholLimits.comment && data.alcoholLimits.comment.value) text += `<br>${data.alcoholLimits.comment.value.text}`

        content.push({
            label: 'Promillegrenze',
            text: text
        })
    }

    if(data.equipment) {
        let text = ''
        if((data.equipment.vestInCar && data.equipment.vestInCar.value) || (data.equipment.vestOnPerson && data.equipment.vestOnPerson.value)){
            text += `${text !== '' ? ', ' : ''}Warnweste`
            let additionalText = ''
            if(data.equipment.vestInCar && data.equipment.vestInCar.value) additionalText += 'Mitführpflicht'
            if(data.equipment.vestOnPerson && data.equipment.vestOnPerson.value) additionalText += `${additionalText !== '' ? ', ' : ''}Tragepflicht`
            if(additionalText !== '') text += ` (${additionalText})`
        }
        if(data.equipment.triangle && data.equipment.triangle.value) text += `${text !== '' ? ', ' : ''}Warndreieck`
        if(data.equipment.firstAidKit && data.equipment.firstAidKit.value) text += `${text !== '' ? ', ' : ''}Verbandszeug`
        if(data.equipment.lamps && data.equipment.lamps.value) text += `${text !== '' ? ', ' : ''}Ersatzlampenset`
        if(data.equipment.fireExtinguisher && data.equipment.fireExtinguisher.value) text += `${text !== '' ? ', ' : ''}Feuerlöscher`
        if(data.equipment.comment && data.equipment.comment.value) text += `${text !== '' ? '. ' : ''}${data.equipment.comment.value.text}`
        if(data.equipment.availableAtOeamtc && (data.equipment.availableAtOeamtc.value === 'true' || data.equipment.availableAtOeamtc.value === true)) text += `<br>Am Stützpunkt erhältlich: <a href="https://www.oeamtc.at/standorte" target="_blank">www.oeamtc.at/standorte</a>`
        if(text !== '') {
            content.push({
                label: 'Mitführpflichten',
                text: text
            })
        }
    }

    if(data.additionalInformation && data.additionalInformation.length > 0) {
        data.additionalInformation.forEach(info => {
            content.push({
                label: info.value.title,
                text: info.value.text + `${info.value.link ? ` <a href="${fixUrl(info.value.link)}" target="_blank">${info.value.link}</a>` : ''}`
            })
        })
    }
    return content
}

function formatChargesInfo(data) {
    const content = []

    const vignetteData = data.filter(d => d.type.indexOf('VIGNETTE') > -1)
    const otherData = data.filter(d => d.type.indexOf('VIGNETTE') < 0)

    vignetteData.forEach(d => {
        const contentItem = {
            label: false,
            text: false,
            subContent: false
        }

        const prices = d.prices && d.prices.length > 0 ? d.prices : false
        if(prices) {
            contentItem.subContent = []
            prices.forEach(price => {
                contentItem.subContent.push({
                    label: price.title.value,
                    text: `${price.amount.value} ${price.currency ? price.currency.value : ''}`
                })
            })
        } else if(d.title) {
            contentItem.label = d.title.value
        }

        if(d.saleLocations && d.saleLocations.value !== '') {
            if(!contentItem.text) contentItem.text = ''
            contentItem.text += `${d.saleLocations.value}`
        }
        if(d.additionalInformation && d.additionalInformation.length > 0) {
            if(!contentItem.text) contentItem.text = ''
            d.additionalInformation.forEach(info => {
                if(info.value && info.value.title && info.value.title !== '') contentItem.text += `<strong>${info.value.title}</strong><br>`
                contentItem.text += `${info.value.text}${info.value.link ? ` <a href="${fixUrl(info.value.link)}" target="_blank">${info.value.link}</a>` : ''}`
            })
        }

        if(contentItem.label || contentItem.subContent) content.push(contentItem)

    })

    otherData.forEach(d => {
        let text = ''
        if(d.additionalInformation && d.additionalInformation.length > 0) {
            d.additionalInformation.forEach(info => {
                if(text !== '') text += '<br><br>'
                if(info.value && info.value.title && info.value.title !== '') text += `<strong>${info.value.title}</strong><br>`
                text += `${info.value.text}${info.value.link ? ` <a href="${fixUrl(info.value.link)}" target="_blank">${info.value.link}</a>` : ''}`
            })
        }
        content.push({
            label: d.title ? d.title.value : '',
            text: text
        })

    })

    return content
}

function formatFuelInfo(data) {
    const content = []

    if(data.averageDieselPrice && data.averageDieselPrice.value) {
        content.push({
            label: 'Diesel',
            text: data.averageDieselPrice.value + ' €'
        })
    }

    if(data.averageSuperPrice && data.averageSuperPrice.value) {
        content.push({
            label: 'Super 95',
            text: data.averageSuperPrice.value + ' €'
        })
    }

    if(data.averageSuperPlusPrice && data.averageSuperPlusPrice.value) {
        content.push({
            label: 'Super 98',
            text: data.averageSuperPlusPrice.value + ' €'
        })
    }

    if(data.additionalInformation && data.additionalInformation.length > 0) {
        data.additionalInformation.forEach(info => {
            content.push({
                label: info.value.title,
                text: info.value.text + `${info.value.link ? ` <a href="${fixUrl(info.value.link)}" target="_blank">${info.value.link}</a>` : ''}`
            })
        })
    }

    return content
}

function formatAdditionalInfo(data) {
    const content = []

    if(data.additionalInformation && data.additionalInformation.length > 0) {
        data.additionalInformation.forEach(info => {
            content.push({
                label: info.value.title,
                text: info.value.text + `${info.value.link ? ` <a href="${fixUrl(info.value.link)}" target="_blank">${info.value.link}</a>` : ''}`
            })
        })
    }

    return content
}